<template>
  <div class="dashboard">
    <div v-if="isMobileApp" class="mobile-overlay"></div>
    <div class="divider"></div>
    <ProfileExperience
      v-if="$root.isMobile && participantAchievements"
      :firstName="profile ? profile.firstName : ''"
      :avatar="avatar"
      :experience="profile ? profile.experience : null"
      :achievements="participantAchievements"
      :sportIndexes="sportIndexes"
      :hideEdit="true"
      :isMobileApp="isMobileApp"
      :steps="steps"
      @show-modal="onStepDynamic"
    />

    <Menu @feedback="showNotifications = false" />

    <SettingUpGuide
      v-if="$root.isMobile"
      v-bind="settingUpGuideOptions"
      :state="bannerTracker"
      @click="onModalTracker"
      @hide="bannerTrackerClose()"
    />

    <div class="divider" v-if="!$root.isMobile"></div>

    <ProfileExperience
      v-if="!$root.isMobile && participantAchievements"
      :firstName="profile ? profile.firstName : ''"
      :avatar="avatar"
      :experience="profile ? profile.experience : null"
      :achievements="participantAchievements"
      :sportIndexes="sportIndexes"
      :hideEdit="true"
      :isMobileApp="isMobileApp"
      :steps="steps"
      @show-modal="onStepDynamic"

    />
    <SettingUpGuide
      v-if="showTrainings"
      v-bind="settingTrainingPlanOptions"
      @click="onModalTrainingsOpen"
      :state="bannerTraining"
      @hide="bannerTreanningClose()"
    />
    <SettingUpGuide
      v-bind="settingMarketOptions"
      @click="onMarketOpen"
      :state="bannerMarket"
      @hide="bannerMarketClose()"
    />

    <SettingUpGuide
      v-if="!$root.isMobile"
      v-bind="settingUpGuideOptions"
      @click="onModalTracker"
      :state="bannerTracker"
      @hide="bannerTrackerClose()"
    />

    <SectionContainer
      title="Задания"
      icon="file-done"
      @goto="onGoTo('TasksAvailable')"
    >
      <div class="stats">
        <div class="stats__card" @click.stop="$router.push({ name: 'TasksInProgress' }).catch(() => {})">
          <div class="stats__card-count">{{ tasksInProgress ? tasksInProgress.total : '' }}</div>
          <div class="stats__card-title">Выполняются</div>
        </div>
        <div class="stats__card" @click.stop="$router.push({ name: 'TasksCompleted' }).catch(() => {})">
          <div class="stats__card-count">{{ tasksCompleted ? tasksCompleted.total : '' }}</div>
          <div class="stats__card-title">Выполнены</div>
        </div>
      </div>
      <div class="recommended">
        <div class="recommended__title" v-if="tasksAvailable ? tasksAvailable.total > 0 : false">Подобрано для вас</div>
        <div class="recommended__slider">
          <Slider
            v-if="tasksAvailable ? tasksAvailable.total > 0 : false"
            :cols="cols"
            :noPagination="noPagination"
            class="tasks-slider"
          >
            <TaskCard
              v-for="(task, i) in tasksAvailable.values"
              :key="i"
              :stateLabels="stateLabels"
              :timeLabels="timeLabels"
              :styleLabels="styleLabels"
              :image="task.images.mobile"
              :action="{ func: () => onShowTask(i) }"
              type="coins"
              state="available"
              :title="task.title"
              :subtitle="task.shortDescription"
              :cost="getTaskRewardRange(task)"
              :date="`${task.endDate}`"
              :itemsTotal="0"
              :itemsDone="0"
              :complexity="task.complexity"
              :isSpecial="task.isSpecial || false"
              :isDaily="task.isDaily || false"
              :isRepeat="false"
              :disciplines="disciplineIcon(task)"
              :chainsCount="task.exerciseChainInfo ? task.exerciseChainInfo.countLinksTotal || 0 : 0"
              :class="{
                'task--chain': task.exerciseChainInfo && task.exerciseChainInfo.countLinksTotal > 0
              }"
            ></TaskCard>
          </Slider>
        </div>
      </div>
    </SectionContainer>
    <div class="banner-wrapper banner-wrapper_gray" v-if="calendarData && calendarData.calendarImages && (calendarData.calendarImages.mobile || calendarData.calendarImages.desktop)">
      <div v-if="$root.isMobile" class="banner">
        <router-link to="/calendar">
          <img :src="calendarData.calendarImages.mobile || ''" />
        </router-link>
      </div>
      <div v-else class="banner">
        <router-link to="/calendar">
          <img :src="calendarData.calendarImages.desktop || ''" />
        </router-link>
      </div>
    </div>
    <SectionContainer
      title="Маркет"
      icon="shopping-bag"
      @goto="onGoTo('Market')"
    >
      <div class="rewards">
        <div class="rewards__slider">
          <Slider
            v-if="promotions ? promotions.total > 0 : false"
            :cols="cols"
            :noPagination="noPagination"
            class="rewards-slider"
          >
            <RewardCard
              v-for="(promotion, i) in promotions.values"
              :key="i"
              :image="promotion.images ? promotion.images.mobile : ''"
              :action="{ func: () => onAction(i) }"
              type='coins'
              :stateLabels="rewardsStateLabels"
              :title="promotion.name"
              :subtitle="promotion.subTitle"
              :cost="promotion.priceInPoints"
              :compactMobile="$root.isMobile"
            ></RewardCard>
          </Slider>
        </div>
      </div>
    </SectionContainer>
    <div class="banner-wrapper" v-if="bannerVk && (bannerVk.mobileImageUrl || bannerVk.desktopImageUrl)">
      <div v-if="$root.isMobile" class="banner">
        <a :href="bannerVk.redirectUrl || ''" target="_blank">
          <img :src="bannerVk.mobileImageUrl || ''" />
        </a>
      </div>
      <div v-else class="banner">
        <a :href="bannerVk.redirectUrl || ''" target="_blank">
          <img :src="bannerVk.desktopImageUrl || ''" />
        </a>
      </div>
    </div>
    <SectionContainer
      v-if="hasNominations"
      title="Рейтинг"
      icon="trophy"
      @goto="onGoTo('Nominations')"
    >
      <div class="nominations">
        <div v-if="isTeamsEnabled && showTeamRatings" class="nominations__types">
          <Button
            v-for="(item, i) in nominationTypes"
            :key="i"
            :variant="i === selectedNominationType ? 'primary' : 'secondary'"
            :disabled="isRatingTypeDisabled(i)"
            size="md"
            mobile
            @click="onChangeNominationType(i)"
          >
            {{ item }}
          </Button>
        </div>
        <div
          class="nominations__slider-container"
          :style="{
            'opacity': (hiddenNominationsSlider ? '0' : '1'),
            'min-height': (nominationsSliderHeight ? nominationsSliderHeight + 'px' : 'auto'),
          }"
          :id="nominationsSliderId"
        >
          <div v-if="!nominationsUpdating && selectedNominationType === 0" class="nominations__slider">
            <Slider
              v-if="nominationsActive ? nominationsActive.total > 0 : false"
              cols="1"
              :slidesPerView="1"
              :loop="true"
              :navigationOffset="nominationsNavigationOffset"
              :paginationOffset="nominationsPaginationOffset"
              class="nominations-slider"
            >
              <NominationCard
                v-for="item in nominationsActive.values"
                :key="item.nominationId"
                type="personal"
                :state="nominationsState"
                :image="getNominationImage(item)"
                :nominationText="getNominationDates(item)"
                :lockedText="{ text: 'Для участия необходимо', link: 'подключить трекер' }"
                :title="item.title"
                :rules="{ text: 'Правила', action: () => onShowRules(item) }"
                :prizes="{ text: 'Награды', action: () => onShowPrizes(item) }"
                :ratingText="{ general: 'Текущий рейтинг', personal: 'Вы в рейтинге' }"
                :values="getNominationRating(item)"
                @show-details="onShowRating(item)"
                @locked-click="onShowOnboarding()"
              ></NominationCard>
            </Slider>
          </div>
          <div v-if="!nominationsUpdating && selectedNominationType === 1" class="nominations__slider">
            <Slider
              v-if="teamNominationsActive ? teamNominationsActive.total > 0 : false"
              cols="1"
              :slidesPerView="1"
              :loop="true"
              :navigationOffset="nominationsNavigationOffset"
              :paginationOffset="nominationsPaginationOffset"
              filterByGroupId="1"
              class="nominations-slider"
            >
              <NominationCard
                v-for="item in teamNominationsActive.values"
                :key="item.nominationId"
                type="personal"
                state="in-progress"
                class="team-rating"
                data-group-id="1"
                :nominationText="getNominationDates(item)"
                :lockedText="{ text: 'Для участия необходимо', link: 'подключить трекер' }"
                :title="item.title"
                :rules="{ text: 'Правила', action: () => onShowRules(item) }"
                :prizes="{ text: 'Награды', action: () => onShowPrizes(item) }"
                :ratingText="{ general: 'Текущий рейтинг', personal: 'Команда в рейтинге' }"
                :values="getNominationRating(item, true)"
                @show-details="onShowRating(item, true)"
              ></NominationCard>
            </Slider>
          </div>
        </div>
      </div>
    </SectionContainer>
    <div class="banner-wrapper" v-if="bannerCommunity && (bannerCommunity.mobileImageUrl || bannerCommunity.desktopImageUrl)">
      <div v-if="$root.isMobile" class="banner">
        <a :href="bannerCommunity.redirectUrl || ''" target="_blank">
          <img :src="bannerCommunity.mobileImageUrl || ''" />
        </a>
      </div>
      <div v-else class="banner">
        <a :href="bannerCommunity.redirectUrl || ''" target="_blank">
          <img :src="bannerCommunity.desktopImageUrl || ''" />
        </a>
      </div>
    </div>
    <SectionContainer
      v-if="isShowGoal && (goalEnabled || goalStepsEnabled)"
      title="Общая цель"
      icon="goal"
      class="bg-gray"
      @goto="onShowDistance()"
    >
      <div class="goal">
        <div class="goal__stats">
          <div class="stats__personal">
            <div class="stats__value" v-html="goalStepsEnabled ? totalDistanceSteps : totalDistance"></div>
            <div class="stats__text">Ваш вклад</div>
          </div>
          <div class="stats__general">
            <div class="stats__value" v-html="goalStepsEnabled ? completedDistanceSteps : completedDistance"></div>
            <div class="stats__text">Общий вклад</div>
          </div>
        </div>
        <div class="goal__compare">
          <div class="compare__text" v-html="compareText"></div>
          <div
            class="compare__graph"
            :style="{ 'background-image': `url('${ $root.isMobile ? goalGraphMobile : goalGraph }')` }"
          >
            <img
              :src="goalTriangle"
              class="graph__marker"
              :style="{
                'left': `calc(${ contributionPercentage-1 }%)`,
                'bottom': `calc(${ goalCoords[contributionPercentage] }px + 8px)`,
              }"
            />
          </div>
        </div>
      </div>
    </SectionContainer>

    <SectionContainer
      id="dashboard-activity"
      title="Активность"
      icon="pulse"
      @goto="onGoTo('Activities')"
    >
      <div class="activity">
        <div class="activity__slider">
          <Slider
            v-if="!loading"
            cols="1"
            :navigationOffset="activityNavigationOffset"
            :paginationOffset="activityPaginationOffset"
            :slidesPerView="1"
            :autoHeight="true"
            class="activity-slider"
            @indexChanged="onSliderIndexChaged"
          >
            <ActivityCard
              v-for="(activity, i) in activities"
              :key="i"
              :title="activity.date"
              :items="activity.items"
            ></ActivityCard>
            <ActivityCard
              :title="activityCardTitle"
              isLast
              @show-all="onGoTo('Activities')"
            ></ActivityCard>
          </Slider>
          <div class="activity__loader" v-if="loading">
            <Loader size="24" />
          </div>
        </div>
      </div>
    </SectionContainer>

    <div class="bottom"></div>

    <div v-if="showNotifications">
      <RrNotifications />
    </div>

    <div class="sneak-bar" v-if="showQuestionnaireSaved || showInstallNotification">
      <Alert
        v-if="showQuestionnaireSaved"
        text="Ваши ответы успешно сохранены."
        actionText="Понятно"
        state="success"
        closable
        autoClose
        stacked
        @close="showQuestionnaireSaved = false"
      ></Alert>
      <Alert
        v-if="showInstallNotification && !isSpecialSettingsMp"
        class="install-notification"
        :text="installNotificationText"
        noIcon
        noAction
        @close="showInstallNotification = false"
      ></Alert>
    </div>
    <div class="sneak-bar">
      <Alert
        v-if="showAlertTargetSteps"
        text="Цель изменена!"
        state="success"
        noAction
        :closable="true"
        :autoClose="true"
      ></Alert>
    </div>

    <WelcomeModal
      v-show="welcomeModal"
      :active="welcomeModal"
      :localizedText="welcomeLocalizedText"
      :isMobileApp="isMobileApp"
      @close="onWelcomeClosed"
    />

    <QuestionnaireModal
      :active="questionnaireModal"
      :localizedText="questionnaireLocalizedText"
      :isMobileApp="isMobileApp"
      @save="onQuestionnaireSave"
      @close="onQuestionnaireClosed"
    />

    <TaskDetailsModal
      :active="taskDetailsModal"
      :state="taskDetailsState"
      :modalOptions="taskDetailsOptions"
      :rating="taskRating"
      @close="onTaskDetailsClose"
      @start="onStart"
    />

    <RulesPrizesModal
      :active="rulesPrizesModal"
      :image="rulesPrizesImage"
      :title="rulesPrizesTitle"
      :subtitle="rulesPrizesSubtitle"
      :nominationId="rulesPrizesNominationId"
      :isTeam="rulesPrizesIsTeam"
      state="personal"
      :tabs="rulesPrizesTabs"
      :activeTab="rulesPrizesTabActive"
      :isMobileApp="isMobileApp"
      @close="onRulesPrizesClosed"
    />

    <DistanceCharityModal
      :active="distanceCharityModal"
      :type="distanceCharityType"
      :localizedText="distanceCharityLocalizedText"
      :isMobileApp="isMobileApp"
      moreLink=""
      @close="onDistanceCharityModalClosed"
    />

    <TrainingsModal
      :active="modalTrainings"
      :isMobileApp="isMobileApp"
      @close="modalTrainings = false"
      @openModaInfo="onModalTrainingsInfoOpen"
      @startTest="onStartQuiz"
    />

    <TrainingsInfoModal
      :active="modalTrainingsInfo"
      :isMobileApp="isMobileApp"
      @close="modalTrainingsInfo = false"
      @startTest="onStartQuiz"
    />

    <TrainingsFinishModal
      :active="modalTrainingsFinish"
      @close="modalTrainingsFinish = false"
      @showPrice="onStartPrice"
    />

    <TrainingsPriceModal
      :active="modalTrainingsPrice"
      @close="modalTrainingsPrice = false"
      @openPlan="modalTrainingsPrice = false"
      @openPlanCoach="modalTrainingsPrice = false"
      @clickSendTrenningsPurchase="clickSendTrenningsPurchase($event)"
    />

    <QuizModal
      :active="quizModal"
      :options="quizOptions"
      @close="onQuizClose"
      @back="onQuizBack"
      @quizEnd="onQuizEnd"
    />

    <TrainingsSuccessModal
      v-if="getEmail"
      :active="modalTrainingsSuccess"
      @close="closeModalTrainingsSuccess"
      :emailProfile="getEmail"
    />

    <StepDynamicModal
      :active="stepDynamicModal"
      :class="{ 'for-mobile-app': isMobileApp }"
      :isMobileApp="isMobileApp"
      :stepDay="stepsHistory"
      @close="onStepDynamicClose"
      @changeTarget="onTargetSteps"
      @goRating="goRating"
    ></StepDynamicModal>

    <TargetStepModal
      :active="stepTargetModal"
      :class="{ 'for-mobile-app': isMobileApp }"
      :isMobileApp="isMobileApp"
      :stepsCount="stepsCount"
      @close="onTargetStepsClose"
      @target-steps-info="onTargetStepsInfo"
      @show-alert="showAlertTargetSteps = true"
      @change-target="changeTarget"
    ></TargetStepModal>

    <Modal
      name="target-steps-info"
      title="Как выбрать количество шагов"
      :img="targetStepsInfoImg"
      :active="targetStepsInfoModal"
      :class="{ 'for-mobile-app': isMobileApp }"
      :noTransition="true"
      @close.prevent="onTargetStepsInfoClose"
      class="target-steps-info__modal"
    >
      <ul>
        <li>менее 5000 шагов в день — характеризуют образ жизни как «сидячий»;</li>
        <li>от 5000 до 7499 шагов в день – показатель не включает спорт и физические нагрузки и считается «малоэффективным»;</li>
        <li>от 7500 до 9999 шагов в день – включает некоторые физические нагрузки или ходьбу (и/или работу, требующую больше ходьбы) и считается «отчасти активным»;</li>
        <li>10000 и более шагов в день характеризуют образ жизни человека как «активный».</li>
      </ul>
    </Modal>

  </div>
</template>

<script>
import { mapGetters, mapActions } from 'vuex';
import dayjs from 'dayjs';
import TaskCard from '@sc-component-library/task-card/src/main';
import RewardCard from '@sc-component-library/reward-card/src/main';
import NominationCard from '@sc-component-library/nomination-card/src/main';
import Alert from '@rr-component-library/alert/src/main';
import TrainingsModal from '@/components/TrainingsModals/TrainingsModal.vue';
import TrainingsInfoModal from '@/components/TrainingsModals/TrainingsInfoModal.vue';
import TrainingsFinishModal from '@/components/TrainingsModals/TrainingsFinishModal.vue';
import TrainingsPriceModal from '@/components/TrainingsModals/TrainingsPriceModal.vue';
import TrainingsSuccessModal from '@/components/TrainingsModals/TrainingsSuccessModal.vue';
import WelcomeModal from '@/components/WelcomeModal/WelcomeModal.vue';
import QuestionnaireModal from '@/components/QuestionnaireModal/QuestionnaireModal.vue';
import QuizModal from '@/components/QuizModal/QuizModal.vue';
import Menu from '@/components/Menu/Menu.vue';
import SectionContainer from '@/components/SectionContainer/SectionContainer.vue';
import ActivityCard from '@/components/ActivityCard/ActivityCard.vue';
import TaskDetailsModal from '@/components/TaskDetailsModal/TaskDetailsModal.vue';
import ProfileExperience from '@/components/ProfileExperience/ProfileExperience.vue';
import RulesPrizesModal from '@/components/RulesPrizesModal/RulesPrizesModal.vue';
import DistanceCharityModal from '@/components/DistanceCharityModal/DistanceCharityModal.vue';
import SettingUpGuide from '@/components/SettingUpGuide/SettingUpGuide.vue';
import RrNotifications from '@/components/Notifications/Notifications.vue';
import Coin from '@/assets/img/coin.png';
import ActivityCover3 from '@/assets/img/activity-card/updated.svg';
import ActivityCoverXP from '@/assets/img/activity-card/xp.svg';
import PointIcon from '@/assets/img/point.svg';
import TrainingRun from '@/assets/icons/training-run.svg';
import TrainingWalk from '@/assets/icons/training-walk.svg';
import TrainingCycling from '@/assets/icons/training-cycling.svg';
import TrainingSwim from '@/assets/icons/training-swim.svg';
import TrainingSki from '@/assets/icons/training-ski.svg';
import TrainingDancing from '@/assets/icons/training-dancing.svg';
import TrainingFitness from '@/assets/icons/training-fitness.svg';
import TrainingStrength from '@/assets/icons/training-strength.svg';
import TrainingMartialArts from '@/assets/icons/training-martial-arts.svg';
import TrainingPlaying from '@/assets/icons/training-playing.svg';
import TrainingExtreme from '@/assets/icons/training-extreme.svg';
import TrainingOutdoor from '@/assets/icons/training-outdoor.svg';
import iOSShare from '@/assets/img/ios-share.svg';
import GoalCoords from '@/assets/data/goalCoords';
import Avatars from '@/assets/data/avatars';
import WHOImage from '@/assets/img/index-ofp/who.svg';
import {
  scrollToId, formatDateRange, addNonBreakingSpaces, formatNumber,
} from '@/assets/js/helpers';
import TargetStepModal from '@/components/TargetStepModal/TargetStepModal.vue';
import StepDynamicModal from '@/components/StepDynamicModal/StepDynamicModal.vue';

const { v4: uuidv4 } = require('uuid');

export default {
  name: 'Dashboard',
  components: {
    TaskCard,
    RewardCard,
    WelcomeModal,
    TrainingsModal,
    TrainingsInfoModal,
    TrainingsFinishModal,
    QuestionnaireModal,
    TrainingsSuccessModal,
    QuizModal,
    Menu,
    SectionContainer,
    ActivityCard,
    TaskDetailsModal,
    ProfileExperience,
    NominationCard,
    Alert,
    RulesPrizesModal,
    DistanceCharityModal,
    SettingUpGuide,
    RrNotifications,
    TrainingsPriceModal,
    StepDynamicModal,
    TargetStepModal,
  },
  data() {
    return {
      stepDynamicModal: false,
      stepsCount: 4000,
      stepTargetModal: false,
      targetStepsInfoModal: false,
      showAlertTargetSteps: false,
      targetStepsInfoImg: WHOImage,
      bannerTraining: false,
      bannerTracker: false,
      bannerMarket: false,
      modalTrainings: false,
      modalTrainingsInfo: false,
      modalTrainingsFinish: false,
      modalTrainingsPrice: false,
      modalTrainingsSuccess: false,
      quizModal: false,
      quizOptions: null,
      stateLabels: {
        available: 'до ', inProgress: 'Выполняется', checking: 'Проверяется', completed: 'Выполнено', failed: 'Вы не успели :(',
      },
      styleLabels: {
        special: 'Особое задание', daily: 'Ежедневное', repeat: 'Многоразовое',
      },
      timeLabels: { days: 'д', hours: 'ч' },
      rewardsStateLabels: {
        available: 'В наличии', count: '5 шт.',
      },
      nominationTypes: ['Личный', 'Командный'],
      selectedNominationType: null,
      nominationsState: 'in-progress',
      hiddenNominationsSlider: false,
      nominationsSliderId: `nominations__slider-container${Math.random().toString().replace('.', '')}`,
      nominationsSliderHeight: 0,
      nominationsUpdating: false,
      rulesPrizesModal: false,
      rulesPrizesImage: '',
      rulesPrizesTitle: '',
      rulesPrizesSubtitle: '',
      rulesPrizesNominationId: '',
      rulesPrizesIsTeam: false,
      rulesPrizesTabs: [
        {
          title: 'Правила',
          enabled: true,
          content: '',
        },
        {
          title: 'Награды',
          enabled: true,
          content: '',
        },
        {
          title: 'Рейтинг',
          enabled: true,
        },
      ],
      rulesPrizesTabActive: 0,
      activities: [],
      welcomeModal: false,
      welcomeLocalizedText: {
        title: '',
        subtitle: '',
        subtitleMarket: `Вам начисленно <b><img src="${Coin}"/> 50</b> приветственных баллов. <br/> Вы можете их потратить на приятные товары в маркете.`,
        actionMarket: { action: this.onWelcomeActionMarket },
      },
      questionnaireModal: false,
      questionnaireLocalizedText: {
        title: 'Анкета участника',
        subtitle: '',
        action: 'Отправить',
      },
      showQuestionnaireSaved: false,
      taskDetailsModal: false,
      taskDetailsState: 'available',
      taskDetailsExerciseId: '',
      taskDetailsOptions: {},
      pageScrollY: 0,
      distanceCharityModal: false,
      distanceCharityType: '',
      distanceCharityLocalizedText: {
        title: '',
        subtitle: '',
      },
      totalDistance: '',
      completedDistance: '',
      goalCoords: GoalCoords,
      contributionPercentage: 0,
      goalStepsEnabled: false,
      goalEnabled: false,
      avatar: '',
      settingUpGuideOptions: {
        icon: 'fitness-tracker',
        text: 'Подключите трекер, чтобы брать спортивные задания',
        actionText: 'Подключить трекер',
      },
      settingTrainingPlanOptions: {
        icon: 'rocket',
        text: 'Тренируйтесь осмысленно с индивидуальным тренировочным планом',
        actionText: 'Получить план',
        actionIconLeft: 'file-done',
        storageKey: 'hideTreainingBanner',
      },
      settingMarketOptions: {
        icon: 'gift',
        text: 'Совершите свою первую покупку',
        actionText: 'Перейти в маркет',
        storageKey: 'hideMarketBanner',
      },
      showInstallNotification: false,
      installNotificationText: `Установите это приложение на iPhone: нажмите<img src="${iOSShare}" />, затем &mdash; На экран "Домой".`,
      loading: true,
      calendarModal: false,
      taskRating: {},
      calendarData: [],
      showNotifications: false,
      hideFeedbackNotificationKey: 'HideFeedbackNotification',
    };
  },
  computed: {
    ...mapGetters('settings', ['theme', 'themeDone', 'options', 'resources']),
    ...mapGetters('user', ['profile', 'isAuthenticated', 'emptyProfile', 'profileAvatar', 'questionnaire', 'questionnaireStatus', 'isMobileApp']),
    ...mapGetters('trackers', ['trackers', 'responseStatus']),
    ...mapGetters('exercises', ['tasksAvailable', 'tasksInProgress', 'tasksCompleted', 'task', 'taskPoints', 'taskGuest', 'responseStatus']),
    ...mapGetters('market', ['promotions']),
    ...mapGetters('achievements', ['participantAchievements']),
    ...mapGetters('operations', ['activityOperations', 'searchEventsData']),
    ...mapGetters('nominations', ['nominationsActive', 'teamNominationsActive']),
    ...mapGetters('goals', ['goal', 'goalSteps']),
    ...mapGetters('calendar', ['calendar']),
    ...mapGetters('trainings', ['sportIndexes']),
    ...mapGetters('content', ['banners']),
    ...mapGetters('steps', ['steps', 'stepsHistory', 'participantPositionData', 'periodSteps']),
    ...mapGetters('participant', ['trainingPlan']),

    isSpecialSettingsMp() {
      return this.options ? this.options.isSpecialSettingsMp === true : false;
    },
    isFirstLogin() {
      return this.$route.query.isFirstLogin === 'true';
    },
    isShowQuestionnaire() {
      return this.$route.query.isShowQuestionnaire === 'true';
    },
    isTrackerConnect() {
      return this.$route.name === 'TrackerConnect' && this.$route.query.connect;
    },
    isTrackerConnected() {
      return this.trackers ? this.trackers.filter((i) => i.state === 'Connected').length > 0 : false;
    },
    isTeamSet() {
      return this.profile ? this.profile.teams !== undefined && this.profile.teams.length > 0 : false;
    },
    profileCreatedOn() {
      return this.profile ? this.profile.createdOn : null;
    },
    isTeamsEnabled() {
      return this.options ? this.options.isTeamsEnabled === true : false;
    },
    showTeamRatings() {
      return this.options ? this.options.showTeamRatings === true : false;
    },
    disableTeamsForGuest() {
      return this.options ? this.options.disableTeamsForGuest === true : false;
    },
    standardWelcomeModal() {
      return this.options ? this.options.customWelcomeModal !== true : true;
    },
    showWelcomeModalMarket() {
      return this.options ? this.options.showWelcomeModalMarket === true : false;
    },
    isShowMarketBanner() {
      return this.options ? this.options.showMarketOnDashboard === true : false;
    },
    showIndexOFP() {
      return this.options ? this.options.showIndexOFP === true : false;
    },
    questionnaireQuestionsCount() {
      return this.options ? this.options.questionnaireQuestionsCount || 3 : 3;
    },
    questionnaireAnswerCost() {
      return this.options ? this.options.questionnaireAnswerCost || 1 : 1;
    },
    showCalendarBanner() {
      return this.options ? this.options.showCalendarBanner === true : false;
    },
    isFeedbackEnabled() {
      return this.options ? this.options.isFeedbackEnabled === true : false;
    },
    goalModalSubtitle() {
      return this.resources ? this.resources.goalModalSubtitle || '' : '';
    },
    bannerDesktop() {
      return this.resources ? this.resources.communityBanner || '' : '';
    },
    bannerMobile() {
      return this.resources ? this.resources.communityBannerMobile || '' : '';
    },
    calendarBanner() {
      return this.resources ? this.resources.calendarBanner || '' : '';
    },
    calendarBannerMobile() {
      return this.resources ? this.resources.calendarBannerMobile || '' : '';
    },
    goalGraph() {
      return this.resources ? this.resources.goalGraph || '' : '';
    },
    goalGraphMobile() {
      return this.resources ? this.resources.goalGraphMobile || '' : '';
    },
    goalTriangle() {
      return this.resources ? this.resources.goalTriangle || '' : '';
    },
    cols() {
      return {
        default: '1', md: '2', lg: '3', xl: '3',
      };
    },
    noPagination() {
      return true;
    },
    activityNavigationOffset() {
      return {
        default: '0', md: '67', lg: '67', xl: '101',
      };
    },
    activityPaginationOffset() {
      return {
        default: '8', md: '12', lg: '12', xl: '28',
      };
    },
    nominationsNavigationOffset() {
      return {
        default: '0', md: '167', lg: '167', xl: '167',
      };
    },
    nominationsPaginationOffset() {
      return {
        default: '8', md: '12', lg: '12', xl: '28',
      };
    },
    hasNominations() {
      if (this.nominationsActive) {
        if (this.nominationsActive.total > 0) return true;
      }
      if (this.teamNominationsActive) {
        if (this.teamNominationsActive.total > 0) return true;
      }
      return false;
    },
    compareText() {
      return addNonBreakingSpaces(`Ваш вклад больше, чем у <span>${formatNumber(this.contributionPercentage, '%')}</span> участников`);
    },
    activityCardTitle() {
      return addNonBreakingSpaces('Более ранние записи в разделе <a href="/activities">«Активность»</a>');
    },
    bannerCalendar() {
      return this.banners ? this.banners.filter((i) => i.locationPlacement === 'calendar')[0] : {};
    },
    bannerVk() {
      if (!this.banners) return null;
      return this.banners.find((i) => i.locationPlacement === 'vk') || null;
    },
    bannerCommunity() {
      return this.banners ? this.banners.filter((i) => i.locationPlacement === 'community')[0] : {};
    },
    isShowGoal() {
      return this.options ? this.options.showGoal !== false : true;
    },
    showTrainings() {
      return this.options ? this.options.showTrainings === true : true;
    },
    getEmail() {
      if (this.profile) {
        return this.profile.emailAddress;
      }
      return '';
    },
  },
  watch: {
    themeDone(val) {
      if (val) {
        if (this.showIndexOFP) this.getIndexes();
      }
    },
    nominationsUpdating(val) {
      if (val) this.hiddenNominationsSlider = true;
      else {
        setTimeout(() => {
          this.nominationsSliderHeight = 0;
          this.hiddenNominationsSlider = false;
        }, 500);
      }
    },
  },
  methods: {
    ...mapActions('user', ['getProfile']),
    ...mapActions('wallet', ['getBalance']),
    ...mapActions('user', ['getQuestionnaire', 'applyAnswers', 'setAvatar']),
    ...mapActions('trackers', ['getTrackers']),
    ...mapActions('exercises', ['getTasksAvailable', 'getTasksInProgress', 'getTasksCompleted', 'getTask', 'getTaskPoints', 'getTaskGuest', 'assignTask']),
    ...mapActions('market', ['getPromotions']),
    ...mapActions('achievements', ['getParticipantAchievements']),
    ...mapActions('operations', ['getActivityOperations', 'searchEvents']),
    ...mapActions('nominations', ['getNominationsActive', 'getTeamNominationsActive']),
    ...mapActions('goals', ['getGoal', 'getGoalSteps']),
    ...mapActions('calendar', ['getCalendar']),
    ...mapActions('trainings', ['getIndexes']),
    ...mapActions('partners', ['createActivity', 'inviteActivity']),
    ...mapActions('content', ['getBanners']),
    ...mapActions('participant', ['physicalLevel', 'sendTrennings', 'getTrainingPlan', 'sendTrenningsPurchase']),
    ...mapActions('steps', ['getSteps', 'getStepsHistory', 'setTargetSteps', 'getParticipantPositionData', 'getPeriodSteps']),
    changeTarget(newCount) {
      this.setTargetSteps({ targetCount: newCount })
        .then(() => {
          this.getSteps();
        }).finally(() => {
          if (this.isMobileApp) {
            this.$root.$goPage(null, '/dashboard');
          } else {
            this.onTargetStepsClose();
          }
          this.showAlertTargetSteps = true;
        });
    },
    goRating() {
      if (this.isMobileApp) {
        this.$root.$goPage('NominationsInProgress', '/rating/in-progress&title=Рейтинг');
      } else {
        this.onStepDynamicClose();
        setTimeout(() => { this.$router.push({ name: 'NominationsInProgress' }).catch(() => {}); }, 500);
      }
    },
    onTargetSteps() {
      this.stepsCount = this.steps ? this.steps.target : 0;
      if (this.isMobileApp) {
        this.$root.$goPage(null, '/dashboard#!showStepTarget=true');
      } else {
        new Promise((resolve) => setTimeout(resolve, 0))
          .then(() => {
            window.location.hash = '#!showStepDynamic=false';
            return new Promise((resolve) => setTimeout(resolve, 200));
          })
          .then(() => {
            window.location.hash = '#!showStepTarget=true';
          });
      }
    },
    onTargetStepsClose() {
      window.location.hash = '#!showStepTarget=false';
    },
    onTargetStepsInfo() {
      if (this.isMobileApp) {
        this.$root.$goPage(null, '/dashboard#!showTargetStepsInfo=true');
      } else {
        window.location.hash = '#!showTargetStepsInfo=true';
      }
    },
    onTargetStepsInfoClose() {
      window.location.hash = '#!showTargetStepsInfo=false';
    },
    onStepDynamic() {
      window.location.hash = '#!showStepDynamic=true';
    },
    onStepDynamicClose() {
      window.location.hash = '#!showStepDynamic=false';
    },
    fetchStepsHistory() {
      const dateTo = dayjs().format('YYYY-MM-DD');
      const dateFrom = dayjs().subtract(30, 'day').format('YYYY-MM-DD');

      this.getStepsHistory({ dateFrom, dateTo });
    },
    clickSendTrenningsPurchase(type) {
      this.sendTrenningsPurchase({ tariffName: type });
      this.modalTrainingsSuccess = true;
    },
    closeModalTrainingsSuccess() {
      this.modalTrainingsSuccess = false;
    },
    bannerTreanningClose() {
      this.bannerTraining = false;
      sessionStorage.setItem('bannerTraining', false);
      if (!this.isTrackerConnected) {
        this.bannerTracker = true;
        sessionStorage.setItem('bannerTracker', true);
      } else {
        this.bannerTracker = false;
        sessionStorage.setItem('bannerTracker', false);
      }
    },
    bannerTrackerClose() {
      this.bannerTracker = false;
      sessionStorage.setItem('bannerTracker', false);
    },
    stateBannerTranning() {
      if (!this.profile.hasParticipantAnyPurchase) {
        this.bannerMarket = true;
      } else if (Object.keys(this.trainingPlan).length === 0 && this.showTrainings) {
        this.bannerTraining = true;
      } else if (!this.isTrackerConnected) {
        if (this.trackers) {
          this.bannerTracker = true;
          sessionStorage.setItem('bannerTracker', true);
        } else {
          this.bannerTracker = false;
          sessionStorage.setItem('bannerTracker', false);
        }
      }
    },
    bannerMarketClose() {
      this.bannerMarket = false;
      sessionStorage.setItem('bannerMarket', false);
      if (Object.keys(this.trainingPlan).length === 0) {
        this.bannerTraining = true;
        sessionStorage.setItem('bannerTraining', true);
      }
      if (!this.isTrackerConnected) {
        this.bannerTracker = true;
        sessionStorage.setItem('bannerTracker', true);
      } else {
        this.bannerTracker = false;
        sessionStorage.setItem('bannerTracker', false);
      }
    },
    onQuizEnd(data) {
      if (data.key) {
        this.quizModal = false;
        this.modalTrainingsFinish = true;
        this.sendTrennings({ trainingPlan: data.key });
        this.getTrainingPlan();
      }
    },
    onStartQuiz() {
      const options = {};
      options.quizId = 86257;
      if (options.quizId) {
        this.quizOptions = options;
        this.modalTrainings = false;
        this.modalTrainingsInfo = false;
        this.quizModal = true;
      }
    },
    onQuizClose() {
      this.quizModal = false;
    },
    onQuizBack() {
      this.quizModal = false;
    },
    onModalTracker() {
      if (this.$root.showOnboarding) {
        localStorage.removeItem('returnToTask');
        this.$root.showOnboarding({ step: 'choose' });
      }
    },
    onModalTrainingsOpen() {
      this.modalTrainings = true;
    },
    onMarketOpen() {
      this.$router.push({ path: '/market' }).catch(() => {});
    },
    onStartPrice() {
      this.modalTrainingsFinish = false;
      this.modalTrainingsPrice = true;
    },
    onModalTrainingsInfoOpen() {
      if (this.modalTrainings) {
        this.modalTrainings = false;
        this.modalTrainingsInfo = true;
      }
    },
    checkProfile() {
      this.getProfile()
        .then(() => {
          if (this.emptyProfile === false && !this.profileAvatar) {
            this.setAvatar({ avatarType: 3 });
          }
          const refValue = sessionStorage.getItem('ref');
          const participantId = this.profile ? this.profile.participantId : undefined;
          if (refValue !== null) {
            const payload = {
              activityId: uuidv4(),
              participantExerciseTaskId: refValue,
              participantId,
            };
            if (participantId) {
              this.inviteActivity(payload)
                .then(() => {
                  sessionStorage.removeItem('ref');
                });
              sessionStorage.removeItem('ref');
            }
          }
          if (this.isAuthenticated) {
            localStorage.removeItem('authEmail');
            localStorage.removeItem('authToken');
            localStorage.removeItem('authDate');
            sessionStorage.removeItem('invitationTeamId');
            sessionStorage.removeItem('marketingProgramCode');
            sessionStorage.removeItem('authFromSSO');
            sessionStorage.removeItem('ssoAccessAttributes');
            if (this.emptyProfile === true) {
              this.$router.push({ name: 'Register' }).catch(() => {});
            } else if (this.isFirstLogin) {
              const opts = this.options || {};
              const teamRequired = (opts.isTeamsEnabled === true) && (opts.isTeamStepRequired === true);
              // На мобильном ждём наличия ответов анкеты, иначе не уходим на Team преждевременно
              if (this.isMobileApp && (!this.questionnaire || !this.questionnaire.answers)) {
                this.showWelcome();
                return;
              }
              const isUnionMemberAnswer = (this.questionnaire && this.questionnaire.answers)
                ? ((this.questionnaire.answers.find((i) => i.key === 'IsUnionMember') || {}).value || '')
                : '';
              const shouldOpenTeam = teamRequired && !this.isTeamSet && (isUnionMemberAnswer === 'true' || isUnionMemberAnswer === '');
              if (shouldOpenTeam) {
                this.$router.push({ name: 'Team', query: this.isMobileApp ? { title: 'Команда' } : {} }).catch(() => {});
              } else {
                this.showWelcome();
              }
            } else if (this.isShowQuestionnaire) {
              this.showQuestionnaire();
            } else if (this.isTrackerConnect) {
              this.showTrackerConnect();
            }
            this.avatar = this.getAvatarImage(this.profile ? this.profile.avatar : null);
            this.getBalance();
            this.getTasksAvailable({ offset: 0, count: 12 });
            this.getTasksInProgress({ offset: 0, count: 12 });
            this.getTasksCompleted({ offset: 0, count: 12 });
            this.getPromotions({ offset: 0, count: 12 });
            this.getCalendarBanner();
            this.getParticipantAchievements(participantId);
            this.getTrackers()
              .then(() => {
                this.stateBannerTranning();
                this.getNominationsActive({ offset: 0, count: 12 })
                  .then(() => {
                    if (this.isTeamsEnabled && this.showTeamRatings) {
                      this.getTeamNominationsActive({ offset: 0, count: 12 })
                        .then(() => {
                          if (this.nominationsActive ? this.nominationsActive.total === 0 : false) {
                            if (this.teamNominationsActive ? this.teamNominationsActive.total > 0 : false) {
                              this.onChangeNominationType(1);
                            } else {
                              this.onChangeNominationType(0);
                            }
                            window.addEventListener('hashchange', this.onHashChange);
                            this.onHashChange();
                            return;
                          }
                          this.onChangeNominationType(0);

                          window.addEventListener('hashchange', this.onHashChange);
                          this.onHashChange();
                        });
                      return;
                    }
                    this.onChangeNominationType(0);

                    window.addEventListener('hashchange', this.onHashChange);
                    this.onHashChange();
                  });
              });
            this.getGoal()
              .then(() => {
                if (this.goal) {
                  this.goalEnabled = this.goal?.isPrimaryGoalEnabled ? this.goal?.isPrimaryGoalEnabled : false;
                  this.contributionPercentage = Math.round(this.goal.contribution.contributionPercentage);
                  this.totalDistance = formatNumber(this.goal.contribution.totalDistance, '<span>км</span>');
                  this.completedDistance = formatNumber(this.goal.completedDistance, '<span>км</span>');
                }
              });
            this.getGoalSteps()
              .then(() => {
                if (this.goalSteps) {
                  this.goalStepsEnabled = this.goalSteps?.isPrimaryGoalEnabled ? this.goalSteps?.isPrimaryGoalEnabled : false;
                  this.contributionPercentageSteps = Math.round(this.goalSteps.contribution.contributionPercentage);
                  this.totalDistanceSteps = formatNumber(this.goalSteps.contribution.totalDistance, '<span>км</span>');
                  this.completedDistanceSteps = formatNumber(this.goalSteps.completedDistance, '<span>км</span>');
                }
              });
            if (this.profile && this.profile.participantId && this.profile.marketingProgramId) {
              const operationTypes = '"OperationType"="Achievement" or "OperationType"="ParticipantExercise" or "OperationType"="ParticipantExperienceLevel" or "OperationType"="ParticipantSteps" or "OperationType"="Purchase" or "OperationType"="SportActivity" or "OperationType"="SporadicActivity" or "OperationType"="TeamParticipant"';
              this.searchEvents({
                subjectId: this.profile.participantId,
                tags: [],
                tagsQuery: operationTypes,
                offset: 0,
                count: 25,
              }).then(() => {
                if (this.searchEventsData && this.searchEventsData.values) {
                  const operations = this.searchEventsData.values.map((event) => this.convertEventToOperation(event));
                  this.activities = this.getMapppedOperations(operations);
                }
                setTimeout(() => { this.loading = false; }, 3000);
              }).catch(() => {
                setTimeout(() => { this.loading = false; }, 3000);
              });
            } else {
              setTimeout(() => { this.loading = false; }, 3000);
            }

            const isIos = () => {
              const userAgent = window.navigator.userAgent.toLowerCase();
              return /iphone|ipad|ipod/.test(userAgent);
            };
            const isSafari = () => navigator.vendor.match(/apple/i);
            const isInStandaloneMode = () => ('standalone' in window.navigator) && (window.navigator.standalone);
            if (isIos() && isSafari && !isInStandaloneMode() && !this.isMobileApp) {
              setTimeout(() => {
                this.showInstallNotification = true;
                setTimeout(() => { this.showInstallNotification = false; }, 15000);
              }, 5000);
            }

            setTimeout(() => { this.checkAndShowFeedback(); }, 3000);
          }
        });
    },
    showWelcome() {
      this.welcomeLocalizedText.title = `${this.profile.firstName || ''}, вы участник!`;
      this.welcomeModal = true;
    },
    onWelcomeClosed() {
      if (this.isMobileApp) {
        this.welcomeModal = false;
        this.$router.replace('/dashboard?isFirstLogin=true#closed').catch(() => {});
        return;
      }
      this.welcomeModal = false;
    },
    onWelcomeActionPrimary() {
      if (this.isMobileApp) {
        this.welcomeModal = false;
        this.$router.replace('/dashboard?isShowQuestionnaire=true').catch(() => {});
        this.showQuestionnaire();
        return;
      }
      window.location.href = '/dashboard?isShowQuestionnaire=true';
      this.welcomeModal = false;
    },
    onWelcomeActionSecondary() {
      if (this.isMobileApp) {
        this.welcomeModal = false;
        this.$router.replace('/dashboard?isFirstLogin=true#closed').catch(() => {});
        return;
      }
      if (!this.showWelcomeModalMarket) {
        window.location.href = '/dashboard';
      } else window.location.href = '/about#textBlock';
      this.welcomeModal = false;
    },
    onWelcomeActionMarket() {
      this.welcomeModal = false;
      const query = { ...this.$router.query };
      delete query.isFirstLogin;
      this.$router.replace({ query }).catch(() => {});
      if (this.isMobileApp) this.$router.push({ name: 'RegisterComplete' }).catch(() => {});
    },
    showQuestionnaire() {
      this.questionnaireLocalizedText.subtitle = `Ответьте на <b>${this.questionnaireQuestionsCount} вопроса(ов)</b>, чтобы получить <img src="${Coin}"/> <b>${this.questionnaireQuestionsCount * this.questionnaireAnswerCost}</b>`;
      this.questionnaireModal = true;
      this.getQuestionnaire();
    },
    showTrackerConnect() {
      this.$root.showOnboarding({ step: 'finish' });
    },
    onQuestionnaireSave(answers) {
      const data = {};
      for (let i = 0; i < answers.length; i += 1) {
        if (answers[i] !== null) data[`Question${i + 1}`] = answers[i].toString();
      }
      this.applyAnswers(data)
        .then(() => {
          if (this.questionnaireStatus === 204) {
            window.removeEventListener('hashchange', this.onHashChange);
            this.questionnaireModal = false;
            setTimeout(() => {
              if (this.isMobileApp) {
                this.questionnaireModal = false;
                this.$router.replace('/dashboard?isShowQuestionnaire=true#saved').catch(() => {});
                return;
              }
              window.location.href = '/dashboard#!showQuestionnaireSaved=true';
            }, 250);
          }
        });
    },
    onQuestionnaireClosed() {
      if (this.isMobileApp) {
        this.questionnaireModal = false;
        this.$router.replace('/dashboard?isShowQuestionnaire=true#closed').catch(() => {});
        return;
      }
      window.location.href = '/dashboard';
      this.questionnaireModal = false;
    },
    onGoTo(routeName) {
      if (routeName) this.$router.push({ name: routeName }).catch(() => {});
    },
    onSliderIndexChaged() {
      scrollToId('dashboard-activity');
    },
    onBanner() {
      this.$router.push({ name: 'Community' }).catch(() => {});
    },
    getCalendarBanner() {
      this.getCalendar()
        .then(() => {
          if (this.responseStatus === 200) {
            this.calendarData = this.calendar ? this.calendar : [];
          }
        });
    },
    onStart() {
      if (this.taskDetailsOptions) {
        if (this.taskDetailsOptions.isTrackerNeeded !== true) {
          const participantExerciseId = uuidv4();
          this.assignTask({ participantExerciseId, exerciseId: this.taskDetailsExerciseId })
            .then(() => {
              if (this.responseStatus === 204) {
                window.scrollTo(0, 0);
                window.location.hash = `#!showTask=${this.taskDetailsExerciseId}&peId=${participantExerciseId}`;
              }
            });
          return;
        }
      }
      if (this.trackers.filter((i) => i.state === 'Connected').length > 0) {
        const participantExerciseId = uuidv4();
        this.assignTask({ participantExerciseId, exerciseId: this.taskDetailsExerciseId })
          .then(() => {
            if (this.responseStatus === 204) {
              window.scrollTo(0, 0);
              window.location.hash = `#!showTask=${this.taskDetailsExerciseId}&peId=${participantExerciseId}`;
            }
          });
        return;
      }
      if (this.$root.showOnboarding) {
        localStorage.setItem('returnToTask', this.taskDetailsExerciseId);
        this.$root.showOnboarding({ step: 'choose' });
      }
    },
    onAction(i) {
      this.$router.push({ name: 'RewardDetails', query: { id: this.promotions.values[i].promotionId, from: 'Dashboard' } }).catch(() => {});
    },
    onShowTask(index) {
      const tasks = this.tasksAvailable.values;
      if (tasks) {
        const task = tasks[index];

        if (task.exerciseChainId) {
          this.$router.push({ name: 'TasksAvailable', query: { showChain: task.exerciseChainId } }).catch(() => {});
        } else {
          localStorage.removeItem('returnToTask');
          window.location.hash = `#!showTask=${task.exerciseId}`;
        }
      }
    },
    onTaskDetailsClose() {
      this.taskDetailsModal = false;
      window.scroll(0, this.pageScrollY);
      window.location.hash = '';
    },
    onHashChange() {
      if (this.$route.name !== 'Dashboard') {
        window.removeEventListener('hashchange', this.onHashChange);
        return;
      }
      const hash = window.location.hash.split('=');
      if (hash[0] === '#!showTask') this.processLoadTask(hash);
      else if (hash[0] === '#!showQuestionnaireSaved') this.processQuestionnaire();
      else if (hash[0] === '#!showNomination') this.showNomination(hash);
      else if (hash[0] === '#!showGoal') this.showGoal(hash);
      else if (hash[0] === '#!showCalendar') this.showCalendar(hash);
      else if (hash[0] === '#!showTargetStepsInfo') this.showTargetStepsInfo(hash);
      else if (hash[0] === '#!showStepDynamic') this.showStepDynamic(hash);
      else if (hash[0] === '#!showStepTarget') this.showStepTarget(hash);
      else {
        this.taskDetailsModal = false;
        this.showQuestionnaireSaved = false;
        this.rulesPrizesModal = false;
        this.distanceCharityModal = false;
        this.calendarModal = false;
        this.targetStepsInfoModal = false;
        this.stepDynamicModal = false;
        this.stepTargetModal = false;
      }
    },
    onShowRules(item) {
      this.rulesPrizesTabs[0].content = item.rules || '';
      this.rulesPrizesTabs[1].content = item.awards || '';
      this.rulesPrizesTabs[2].enabled = false;
      this.rulesPrizesTabActive = 0;
      this.rulesPrizesImage = this.getNominationImage(item);
      this.rulesPrizesTitle = this.getNominationDates(item);
      this.rulesPrizesSubtitle = item.title;
      this.rulesPrizesModal = true;
    },
    onShowPrizes(item) {
      this.rulesPrizesTabs[0].content = item.rules || '';
      this.rulesPrizesTabs[1].content = item.awards || '';
      this.rulesPrizesTabs[2].enabled = false;
      this.rulesPrizesTabActive = 1;
      this.rulesPrizesImage = this.getNominationImage(item);
      this.rulesPrizesTitle = this.getNominationDates(item);
      this.rulesPrizesSubtitle = item.title;
      this.rulesPrizesModal = true;
    },
    onShowRating(item, isTeam = false) {
      this.rulesPrizesTabs[0].content = item.rules || '';
      this.rulesPrizesTabs[1].content = item.awards || '';
      this.rulesPrizesTabs[2].enabled = true;
      this.rulesPrizesTabActive = 2;
      this.rulesPrizesImage = this.getNominationImage(item);
      this.rulesPrizesTitle = this.getNominationDates(item);
      this.rulesPrizesSubtitle = item.title;
      this.rulesPrizesNominationId = item.nominationId;
      this.rulesPrizesIsTeam = isTeam;
      this.rulesPrizesModal = true;
    },
    onRulesPrizesClosed() {
      window.location.hash = '';
      this.rulesPrizesModal = false;
    },
    onShowOnboarding() {
      this.$root.showOnboarding({ step: 'choose' });
    },
    onShowDistance() {
      window.location.hash = '#!showGoal=true';
      this.distanceCharityType = 'distance';
      this.distanceCharityLocalizedText = {
        title: 'Вместе преодолеть',
        subtitle: this.goalModalSubtitle ? this.goalModalSubtitle : 'Бегайте и ходите. Внесите свой вклад в достижение общей цели.',
      };
      this.distanceCharityModal = true;
    },
    onDistanceCharityModalClosed() {
      window.location.hash = '#!showGoal=false';
    },
    onChangeNominationType(index) {
      if (this.selectedNominationType === index) return;
      this.updateHeight();
      this.selectedNominationType = -1;
      setTimeout(() => { this.nominationsUpdating = true; }, 100);
      setTimeout(() => {
        this.selectedNominationType = index;
        this.nominationsUpdating = false;
      }, 400);
    },
    onFeedback() {
      if (!window.Userback) return;
      this.showNotifications = false;
      window.Userback.open('general');
      this.setUserbackEventListener();
    },
    onUserbackSend() {
      this.showNotifications = false;
      // Скрыть уведомление на 30 суток
      const date = (Date.now() + 30 * 24 * 60 * 60 * 1000).toString();
      this.saveDuration(date);
    },
    processLoadTask(hash) {
      if (hash.length === 2) {
        this.loadTask(hash[1]);
      }
      if (hash.length === 3 && hash[1].indexOf('&peId') >= 0) {
        this.loadMyTask(hash[1].split('&peId')[0], hash[2]);
      }
    },
    processQuestionnaire() {
      this.showQuestionnaireSaved = true;
      setTimeout(() => { window.location.hash = ''; }, 1000);
    },
    showNomination(hash) {
      if (!hash[1]) {
        this.rulesPrizesModal = false;
        this.clearHash();
        return;
      }
      if (hash[1] === 'false') {
        this.rulesPrizesModal = false;
        this.clearHash();
        return;
      }

      const nominationId = hash[1] || '';
      if (!nominationId) {
        this.clearHash();
        return;
      }

      const personal = this.nominationsActive ? this.nominationsActive.values.filter((i) => i.nominationId === nominationId) : [];
      if (personal.length > 0) {
        this.onShowRating(personal[0]);
        return;
      }

      const team = this.teamNominationsActive ? this.teamNominationsActive.values.filter((i) => i.nominationId === nominationId) : [];
      if (team.length > 0) {
        this.onShowRating(team[0]);
      }
    },
    showGoal(hash) {
      if (hash[1] === 'true') this.onShowDistance();
      else {
        this.distanceCharityModal = false;
        this.clearHash();
      }
    },
    showCalendar(hash) {
      if (hash[1] === 'true') this.getCalendarBanner();
      else {
        this.calendarModal = false;
        this.clearHash();
      }
    },
    showTargetStepsInfo(hash) {
      if (hash[1] === 'true') this.targetStepsInfoModal = true;
      else {
        this.targetStepsInfoModal = false;
        this.clearHash();
      }
    },
    showStepDynamic(hash) {
      if (hash[1] === 'true') this.stepDynamicModal = true;
      else {
        this.stepDynamicModal = false;
        this.clearHash();
      }
    },
    showStepTarget(hash) {
      if (hash[1] === 'true') this.stepTargetModal = true;
      else {
        this.stepTargetModal = false;
        this.clearHash();
      }
    },
    loadTask(id) {
      this.getTaskGuest(id)
        .then(() => {
          if (this.taskGuest) {
            this.pageScrollY = window.scrollY;
            this.taskDetailsState = 'available';
            this.taskDetailsExerciseId = id;
            this.taskDetailsOptions = this.taskGuest;
            if (id && id !== 'null' && id !== 'undefined') {
              this.getTaskPoints(id)
                .then(() => {
                  this.taskRating = this.taskPoints;
                });
            }
            this.taskDetailsModal = true;
            return;
          }
          window.location.hash = '';
        });
    },
    loadMyTask(id, peId) {
      this.getTask(peId)
        .then(() => {
          if (this.task) {
            this.pageScrollY = window.scrollY;
            this.taskDetailsState = this.getTaskDetailsState(this.task);
            this.taskDetailsExerciseId = peId;
            this.taskDetailsOptions = this.task;
            if (id && id !== 'null' && id !== 'undefined') {
              this.getTaskPoints(id)
                .then(() => {
                  this.taskRating = this.taskPoints;
                });
            }
            this.taskDetailsModal = true;
            return;
          }
          window.location.hash = `#!showTask=${id}`;
        });
    },
    getTaskReward(task) {
      // Если есть reward на уровне задания, используем его
      if (task && task.reward !== undefined && task.reward !== null) {
        return Math.round(task.reward);
      }

      // Иначе используем старую логику - суммируем из tasks
      let reward = 0;
      if (!task || !task.tasks) return reward;
      for (let i = 0; i < task.tasks.length; i += 1) {
        reward += task.tasks[i].reward;
      }
      return Math.round(reward);
    },
    getTaskRewardRange(task) {
      // Если есть reward на уровне задания, используем его (без диапазона)
      if (task && task.reward !== undefined && task.reward !== null) {
        return Math.round(task.reward);
      }

      // Для цепочек используем reward из exerciseChainInfo
      if (task.exerciseChainInfo) {
        const reward = task.exerciseChainInfo.reward || 0;
        const maxReward = task.exerciseChainInfo.maxReward || 0;
        return maxReward && reward < maxReward ? `${Math.round(reward)}-${maxReward}` : Math.round(reward);
      }

      // Для обычных заданий используем старую логику
      let reward = 0;
      let maxReward = 0;
      if (!task || !task.tasks) return reward;
      for (let i = 0; i < task.tasks.length; i += 1) {
        reward += task.tasks[i].reward;
        maxReward += task.tasks[i].maxReward;
      }
      return maxReward && reward < maxReward ? `${Math.round(reward)}-${maxReward}` : Math.round(reward);
    },
    getIsFlexibleCost(task) {
      const reward = this.getTaskReward(task);
      if (!task || !task.tasks) return false;
      let maxReward = 0;
      for (let i = 0; i < task.tasks.length; i += 1) {
        maxReward += task.tasks[i].maxReward;
      }
      return reward < maxReward;
    },
    isRepeat(task) {
      return task.type === 'Reusable';
    },
    getMetadataValue(metadata, name) {
      const item = metadata.find((m) => m.name === name);
      return item ? item.value : null;
    },
    getOperationType(event) {
      const tag = event.tags.find((t) => t.key === 'OperationType');
      return tag ? tag.value : null;
    },
    convertEventToOperation(event) {
      const operationType = this.getOperationType(event);
      const attributes = {};
      event.metadata.forEach((meta) => {
        attributes[meta.name] = meta.value;
      });

      // Добавляем данные из objects (для заданий и других сущностей)
      if (event.objects && event.objects.length > 0) {
        event.objects.forEach((obj) => {
          if (obj.metadata) {
            obj.metadata.forEach((meta) => {
              // Добавляем, только если ещё нет в attributes
              if (!attributes[meta.name]) {
                attributes[meta.name] = meta.value;
              }
            });
          }
        });
      }

      // Получаем ExerciseId из tags или metadata
      let exerciseId = null;
      // Пробуем найти в metadata
      exerciseId = this.getMetadataValue(event.metadata, 'ExerciseId');

      const activityIdTag = event.tags && event.tags.find((t) => t.key === 'ActivityId');
      const activityId = activityIdTag ? activityIdTag.value : null;

      return {
        operationId: event.eventId,
        operationType,
        operationDate: event.operationDate || event.eventDate,
        operationSourceId: this.getMetadataValue(event.metadata, 'OperationSourceId'),
        sourceId: exerciseId,
        attributes,
        state: 'Synchronized',
        activityId,
      };
    },
    hasSameTimeAndType(operation1, operation2) {
      if (!operation1 || !operation2) {
        return false;
      }
      const isTraining = (op) => op.operationType === 'SportActivity' || op.operationType === 'SporadicActivity';
      if (!isTraining(operation1) || !isTraining(operation2)) {
        return false;
      }
      const date1 = dayjs(operation1.operationDate);
      const date2 = dayjs(operation2.operationDate);
      if (!date1.isValid() || !date2.isValid()) {
        return false;
      }
      return date1.isSame(date2, 'second');
    },
    filterOperationsByTime(operations) {
      const filteredOperations = [];
      let previousOperation = null;
      for (let i = 0; i < operations.length; i += 1) {
        const currentOperation = operations[i];
        if (previousOperation && this.hasSameTimeAndType(previousOperation, currentOperation)) {
          previousOperation.title += `, ${this.getFormattedDistance(currentOperation)}`;
        } else {
          filteredOperations.push(currentOperation);
          previousOperation = currentOperation;
        }
      }
      return filteredOperations;
    },
    getMapppedOperations(operations) {
      if (!operations) return [];
      const filteredOperations = this.filterOperationsByTime(operations);
      const days = [];
      let currentDay = { date: '', items: [] };
      let sportActivities = [];
      let lastDate = '';
      for (let i = 0; i < filteredOperations.length; i += 1) {
        const value = filteredOperations[i];
        const date = dayjs.utc(value.operationDate).local();
        if (!date.isValid()) continue;
        const formattedDate = date.format('D MMMM');
        const item = this.getMappedItem(value);
        const currentDate = date.format('YYYY-MM-DD');
        if (currentDate !== lastDate) {
          if (lastDate !== '') {
            days.push(currentDay);
          }
          currentDay = { date: formattedDate, items: [] };
          sportActivities = [];
        }
        if (value.operationType === 'SportActivity' || value.operationType === 'SporadicActivity') {
          const existingSportActivity = sportActivities.find((activity) => activity.time === item.time);
          const isSameActivity = existingSportActivity && (
            existingSportActivity.operationId === value.activityId
            || existingSportActivity.activityId === value.operationId
          );
          if (existingSportActivity && isSameActivity) {
            // Та же активность (SportActivity + SporadicActivity): не менять заголовок — оставляем дисциплинарный
          } else if (existingSportActivity) {
            existingSportActivity.activityTexts = existingSportActivity.activityTexts || [];
            existingSportActivity.activityTexts.push(item.activityText);
            const trainingsLink = '/my-settings/trainings';
            const mobileTrainingsLink = `${trainingsLink}?title=Мой аккаунт`;
            const texts = existingSportActivity.activityTexts;
            const allSame = texts.length > 0 && texts.every((t) => t === texts[0]);
            const formattedList = allSame ? `${texts[0]} (${texts.length})` : new Intl.ListFormat('ru').format(texts);
            existingSportActivity.title = `Получены новые тренировки: <a href="${this.isMobileApp ? mobileTrainingsLink : trainingsLink}">${formattedList}</a>`;
          } else {
            item.titles = [item.title];
            item.activityTexts = [item.activityText];
            // Одна тренировка — только дисциплинарный заголовок из getMappedItem. «Получены новые тренировки» только при нескольких за одно время.
            if (!item.title) {
              const trainingsLink = '/my-settings/trainings';
              const mobileTrainingsLink = `${trainingsLink}?title=Мой аккаунт`;
              item.title = `Получена тренировка: <a href="${this.isMobileApp ? mobileTrainingsLink : trainingsLink}">${item.activityText}</a>`;
            }
            currentDay.items.push(item);
            sportActivities.push(item);
          }
        } else {
          currentDay.items.push(item);
        }
        lastDate = currentDate;
      }
      if (currentDay.items.length > 0) {
        days.push(currentDay);
      }
      return days;
    },
    pluralizeSteps(count) {
      if (count % 10 === 1 && count % 100 !== 11) {
        return `<b>${count}</b> шаг`;
      } if (count % 10 >= 2 && count % 10 <= 4 && (count % 100 < 10 || count % 100 >= 20)) {
        return `<b>${count}</b> шага`;
      }
      return `<b>${count}</b> шагов`;
    },
    getMappedItem(value) {
      const item = {};
      // Нормализация без мутации параметра: если пришёл ответ с metadata/tags без attributes/operationType (сырой API)
      let resolvedAttributes = {};
      if (value && value.attributes && typeof value.attributes === 'object') {
        resolvedAttributes = value.attributes;
      } else if (value && Array.isArray(value.metadata)) {
        const fromMetadata = Object.fromEntries(value.metadata.map((m) => [m.name, m.value]));
        // Иногда API отдаёт одно поле metadata: { name: "Data", value: "{...json...}" }
        if (fromMetadata && typeof fromMetadata.Data === 'string' && fromMetadata.Data.trim().startsWith('{')) {
          try {
            const parsed = JSON.parse(fromMetadata.Data);
            resolvedAttributes = parsed && typeof parsed === 'object' ? parsed : fromMetadata;
          } catch (e) {
            resolvedAttributes = fromMetadata;
          }
        } else {
          resolvedAttributes = fromMetadata;
        }
      }
      const resolvedOperationType = value && (value.operationType != null
        ? value.operationType
        : (value.tags && value.tags.find((t) => t.key === 'OperationType')?.value));
      const val = value ? { ...value, attributes: resolvedAttributes, operationType: resolvedOperationType } : value;

      if (!val) return item;
      if (val.operationType === 'TeamParticipant') {
        item.time = dayjs.utc(val.operationDate).local().format('HH:mm');
        item.img = val.attributes.TeamLogo || '';
        item.isInternalImg = false;
        if (val.attributes.StateOperation === 'Created') {
          item.title = `Вы присоединились к команде <a href="/my-team">${val.attributes.TeamName}`;
        } else {
          item.title = `Вы покинули команду <span class="team-out">${val.attributes.TeamName}</span>`;
          item.taskStatus = 'rejected';
        }
        return item;
      }
      if (val.operationType === 'Purchase') {
        item.img = val.attributes.ProductMobileImageUrl || '';
        item.isInternalImg = false;
        item.title = `Вы купили <a href="/market/reward?id=${val.attributes.PromotionId || ''}">${val.attributes.ProductName}`;
        item.time = dayjs.utc(val.operationDate).local().format('HH:mm');
        item.coins = -Math.round(val.attributes.Amount);
        return item;
      }
      if (val.operationType === 'ParticipantExercise') {
        item.img = val.attributes.ExerciseMobileImageUrl || '';
        item.isInternalImg = false;
        item.time = dayjs.utc(val.operationDate).local().format('HH:mm');

        if (['RejectedManually', 'Rejected'].includes(val.attributes.StateOperation)) {
          item.taskStatus = 'rejected';
          item.title = `Отменено задание <a href="#!showTask=${val.sourceId}">${val.attributes.ExerciseTitle}</a>`;
        } else if (val.attributes.StateOperation === 'Completed') {
          item.taskStatus = 'completed';
          item.title = `${this.getFormattedTaskState(val)} <a href="#!showTask=${val.sourceId}&peId=${val.operationSourceId}">${val.attributes.ExerciseTitle}</a>`;
          const rewardNum = parseFloat(val.attributes.Reward);
          if (!Number.isNaN(rewardNum) && rewardNum > 0) {
            item.coins = `+${Math.round(rewardNum)}`;
          }
        } else {
          // Для Created и других статусов - без иконки
          item.title = `${this.getFormattedTaskState(val)} <a href="#!showTask=${val.sourceId}&peId=${val.operationSourceId}">${val.attributes.ExerciseTitle}</a>`;
        }
        return item;
      }
      // SportActivity и SporadicActivity — одна и та же логика отображения (иконка по дисциплине, заголовок, награды)
      if (val.operationType === 'SportActivity' || val.operationType === 'SporadicActivity') {
        const discipline = val.attributes.Discipline || '';

        item.operationId = val.operationId;
        item.activityId = val.activityId || null;
        item.img = this.getTrainingIcon(discipline);
        item.isInternalImg = true;
        item.time = dayjs.utc(val.operationDate).local().format('HH:mm');

        const trainingsLink = '/my-settings/trainings';
        const mobileTrainingsLink = `${trainingsLink}?title=Мой аккаунт`;
        const finalTrainingsLink = this.isMobileApp ? mobileTrainingsLink : trainingsLink;
        const activityTitle = this.getFormattedSportActivityTitle(val, finalTrainingsLink);

        const activityText = val.attributes.Distance ? this.getFormattedDistance(val) : this.formatValue(val);
        item.activityText = activityText;
        item.title = activityTitle;

        const coinsValue = val.attributes.Reward
          || val.attributes.AccruedPoints
          || val.attributes.Coins
          || val.attributes.Amount
          || val.attributes.Points;
        if (coinsValue && parseFloat(coinsValue) > 0) {
          item.coins = `+${Math.round(parseFloat(coinsValue))}`;
        }

        const pointsValue = val.attributes.RatingPoints
          || val.attributes.Experience
          || val.attributes.XP
          || val.attributes.ExperiencePoints;
        if (pointsValue && parseFloat(pointsValue) > 0) {
          item.points = `+${Math.round(parseFloat(pointsValue))}`;
        }

        return item;
      }
      if (val.operationType === 'Achievement') {
        item.img = val.attributes.ActiveIcon;
        item.isInternalImg = true;
        item.title = `Вы разблокировали достижение <b>${val.attributes.Title}</b>`;
        item.time = dayjs.utc(val.operationDate).local().format('HH:mm');
        return item;
      }
      if (val.operationType === 'ParticipantExperienceLevel') {
        item.img = ActivityCoverXP;
        item.isInternalImg = true;
        item.title = `Вы достигли <b>${val.attributes.Level} ур.</b>`;
        item.time = dayjs.utc(val.operationDate).local().format('HH:mm');
        return item;
      }
      if (val.operationType === 'ParticipantExperience') {
        item.img = PointIcon;
        item.isInternalImg = true;
        const xpValue = val.attributes.Value ? Math.round(parseFloat(val.attributes.Value)) : 0;
        if (val.attributes.ExerciseTitle && val.sourceId) {
          item.title = `Начислено <b>${xpValue}</b> очков рейтинга за выполнение задания <a href="#!showTask=${val.sourceId}">${val.attributes.ExerciseTitle}</a>`;
        } else if (val.attributes.ExerciseTitle) {
          item.title = `Начислено <b>${xpValue}</b> очков рейтинга за выполнение задания <b>${val.attributes.ExerciseTitle}</b>`;
        } else {
          item.title = `Начислено <b>${xpValue}</b> очков рейтинга`;
        }
        item.time = dayjs.utc(val.operationDate).local().format('HH:mm');
        return item;
      }
      if (val.operationType === 'ParticipantSteps') {
        item.isInternalImg = false;
        item.img = '';
        item.isTaskSteps = true;
        item.StepsCount = Math.round(val.attributes.StepsCount);
        item.title = `Вы прошли ${this.pluralizeSteps(item.StepsCount)}`;
        item.time = dayjs.utc(val.operationDate).local().format('HH:mm');
        const accruedNum = parseFloat(val.attributes?.AccruedPoints);
        if (!Number.isNaN(accruedNum) && accruedNum > 0) {
          item.coins = `+${Math.round(accruedNum)}`;
        }
        return item;
      }
      item.img = '';
      item.isInternalImg = false;
      item.achievementType = '';
      item.title = '';
      item.time = dayjs.utc(val.operationDate).local().format('HH:mm');
      return item;
    },
    formatValue(value) {
      const { attributes } = value;
      let discipline = attributes.Discipline || '';
      if (discipline === 'Dancing') {
        discipline = 'Танцы';
      } if (discipline === 'Fitness') {
        discipline = 'Гибкость и контроль';
      } if (discipline === 'Strength') {
        discipline = 'Силовые тренировки';
      } if (discipline === 'MartialArts') {
        discipline = 'Боевые искусства';
      } if (discipline === 'Playing') {
        discipline = 'Игровые виды спорта';
      } if (discipline === 'Extreme') {
        discipline = 'Экстремальные и outdoor-активности';
      } if (discipline === 'Outdoor') {
        discipline = 'Свободная тренировка';
      }

      if (!discipline) discipline = 'Тренировка';

      const rawTime = attributes.TimeInSeconds;
      const parsedTime = rawTime !== undefined && rawTime !== null && rawTime !== ''
        ? parseInt(rawTime, 10)
        : NaN;
      const hasTime = Number.isFinite(parsedTime) && parsedTime > 0;

      const rawCalories = attributes.Calories ?? attributes.calories;
      const parsedCalories = rawCalories !== undefined && rawCalories !== null && rawCalories !== ''
        ? Number(rawCalories)
        : NaN;
      const hasCalories = Number.isFinite(parsedCalories) && parsedCalories > 0;

      const rawPulse = attributes.Pulse;
      const parsedPulse = rawPulse !== undefined && rawPulse !== null && rawPulse !== ''
        ? Number(rawPulse)
        : NaN;
      const hasPulse = Number.isFinite(parsedPulse) && parsedPulse > 0;

      let timeFormatted = '';
      if (hasTime) {
        const hours = Math.floor(parsedTime / 3600);
        const minutes = Math.floor((parsedTime % 3600) / 60);
        const seconds = parsedTime % 60;
        timeFormatted = `${hours}:${minutes.toString().padStart(2, '0')}:${seconds.toString().padStart(2, '0')}`;
      }

      const caloriesText = hasCalories ? `${Number.isInteger(parsedCalories) ? parsedCalories : parsedCalories.toFixed(0)} ккал` : '';
      const pulseText = !hasCalories && hasPulse ? `${Number.isInteger(parsedPulse) ? parsedPulse : parsedPulse.toFixed(0)} уд/мин` : '';
      return [discipline, timeFormatted, caloriesText || pulseText].filter(Boolean).join(' • ');
    },
    getTrainingIcon(discipline) {
      if (discipline === 'Running') return TrainingRun;
      if (discipline === 'Walking') return TrainingWalk;
      if (discipline === 'Cycling') return TrainingCycling;
      if (discipline === 'Swimming') return TrainingSwim;
      if (discipline === 'Skiing') return TrainingSki;
      if (discipline === 'Dancing') return TrainingDancing;
      if (discipline === 'Fitness') return TrainingFitness;
      if (discipline === 'Strength') return TrainingStrength;
      if (discipline === 'MartialArts') return TrainingMartialArts;
      if (discipline === 'Playing') return TrainingPlaying;
      if (discipline === 'Extreme') return TrainingExtreme;
      if (discipline === 'Outdoor') return TrainingOutdoor;
      return ActivityCover3; // fallback
    },
    getFormattedSportActivityTitle(value, trainingsLink = '/my-settings/trainings') {
      if (!value || !value.attributes) return '';
      const { attributes } = value;
      const discipline = attributes.Discipline || '';
      const distance = attributes.Distance ? parseInt(attributes.Distance, 10) : null;
      const timeInSeconds = attributes.TimeInSeconds ? parseInt(attributes.TimeInSeconds, 10) : 0;
      const calories = attributes.Calories ?? attributes.calories;
      const hasCalories = calories !== undefined && calories !== null && Number(calories) > 0;

      const rawPulse = attributes.Pulse;
      const parsedPulse = rawPulse !== undefined && rawPulse !== null && rawPulse !== ''
        ? Number(rawPulse)
        : NaN;
      const hasPulse = Number.isFinite(parsedPulse) && parsedPulse > 0;

      // Форматирование расстояния
      let distanceText = '';
      if (distance !== null && distance > 0) {
        const unit = distance >= 1000 ? 'км' : 'м';
        let formatted = '';
        if (distance >= 1000) {
          formatted = (distance / 1000).toFixed(2);
          if (formatted[formatted.length - 1] === '0') formatted = formatted.slice(0, formatted.length - 1);
          if (formatted.indexOf('.0') >= 0) formatted = formatted.slice(0, formatted.indexOf('.0'));
          formatted = formatted.replace('.', ',');
        } else {
          formatted = distance.toString();
        }
        distanceText = `<a href="${trainingsLink}" style="color: var(--color-primary, #FF8233); font-weight: 600; text-decoration: none;">${formatted} ${unit}</a>`;
      }

      // Форматирование времени
      let durationText = '';
      if (timeInSeconds > 0) {
        const minutes = Math.floor(timeInSeconds / 60);
        durationText = `<a href="${trainingsLink}" style="color: var(--color-primary, #FF8233); font-weight: 600; text-decoration: none;">${minutes} мин</a>`;
      }

      // Калории или пульс: при наличии калорий показываем их, иначе — пульс; ни то ни другое — ничего
      const caloriesText = hasCalories
        ? `<a href="${trainingsLink}" style="color: var(--color-primary, #FF8233); font-weight: 600; text-decoration: none;">${Number(calories)} ккал</a>`
        : '';
      const pulseText = !hasCalories && hasPulse
        ? `<a href="${trainingsLink}" style="color: var(--color-primary, #FF8233); font-weight: 600; text-decoration: none;">${Number.isInteger(parsedPulse) ? parsedPulse : parsedPulse.toFixed(0)} уд/мин</a>`
        : '';
      const caloriesOrPulseText = caloriesText || pulseText;

      // Формирование текста в зависимости от дисциплины
      let prefix = '';
      if (discipline === 'Running') {
        prefix = 'Получена тренировка по бегу:';
      } else if (discipline === 'Walking') {
        prefix = 'Получена тренировка по ходьбе:';
      } else if (discipline === 'Cycling') {
        prefix = 'Получена велотренировка:';
      } else if (discipline === 'Swimming') {
        prefix = 'Получена тренировка по плаванию:';
      } else if (discipline === 'Skiing') {
        prefix = 'Получена тренировка по лыжам:';
      } else if (discipline === 'Dancing') {
        prefix = 'Получена тренировка по танцам:';
      } else if (discipline === 'Fitness') {
        prefix = 'Получена тренировка на гибкость и контроль:';
      } else if (discipline === 'Strength') {
        prefix = 'Получена силовая тренировка:';
      } else if (discipline === 'MartialArts') {
        prefix = 'Получена тренировка по боевым искусствам:';
      } else if (discipline === 'Playing') {
        prefix = 'Получена тренировка по игровым видам спорта:';
      } else if (discipline === 'Extreme') {
        prefix = 'Получена тренировка по экстремальным видам спорта:';
      } else if (discipline === 'Outdoor') {
        prefix = 'Получена свободная тренировка:';
      }
      if (['Dancing', 'Fitness', 'Strength', 'MartialArts', 'Playing', 'Extreme', 'Outdoor'].includes(discipline)) {
        const parts = [durationText, caloriesOrPulseText].filter(Boolean);
        return parts.length ? `${prefix} ${parts.join(', ')}` : prefix;
      }
      if (!prefix) {
        prefix = 'Получена тренировка:';
      }

      // Для циклических видов спорта показываем расстояние, время и калории/пульс при наличии
      const cyclicParts = [distanceText, durationText, caloriesOrPulseText].filter(Boolean);
      if (cyclicParts.length) {
        return `${prefix} ${cyclicParts.join(', ')}`;
      }

      return prefix;
    },
    getFormattedDistance(value) {
      if (!value || !value.attributes) return '';
      const distance = parseInt(value.attributes.Distance, 10);
      const unit = distance >= 1000 ? 'км' : 'м';
      let formatted = '';
      if (distance >= 1000) {
        formatted = (distance / 1000).toFixed(2);
        if (formatted[formatted.length - 1] === '0') formatted = formatted.slice(0, formatted.length - 1);
        if (formatted.indexOf('.0') >= 0) formatted = formatted.slice(0, formatted.indexOf('.0'));
        formatted = formatted.replace('.', ',');
      } else {
        formatted = distance.toString();
      }
      if (value.attributes.Discipline === 'Walking') return `${formatted} ${unit} ходьба`;
      if (value.attributes.Discipline === 'Running') return `${formatted} ${unit} бег`;
      if (value.attributes.Discipline === 'Cycling') return `${formatted} ${unit} велозаезд`;
      if (value.attributes.Discipline === 'Swimming') return `${formatted} ${unit} плавание`;
      if (value.attributes.Discipline === 'Skiing') return `${formatted} ${unit} лыжи`;
      return '';
    },
    getFormattedTaskState(value) {
      if (!value || !value.attributes) return '';
      if (value.attributes.StateOperation === 'Created') return 'Вы начали задание';
      if (value.attributes.StateOperation === 'Completed') return 'Вы успешно выполнили задание';
      return '';
    },
    getTaskDetailsState(task) {
      if (!task.participantExercise) return 'available';
      if (task.participantExercise.state === 'Created') return 'inProgress';
      if (task.participantExercise.state === 'Completed') return 'completed';
      if (task.participantExercise.state === 'Rejected') return 'failed';
      if (task.participantExercise.state === 'AwaitingConfirmation') return 'checking';
      return '';
    },
    getNominationImage(item) {
      if (!item || !item.images) return '';
      return this.$root.isDesktop ? item.images.desktop || '' : item.images.mobile || '';
    },
    getNominationDates(item) {
      if (!item) return '';
      const startDate = dayjs.utc(item.startDate);
      const finishDate = dayjs.utc(item.finishDate);
      if (startDate.isValid() && finishDate.isValid()) {
        return formatDateRange({ start: startDate, finish: finishDate, showYear: true });
      }
      return '';
    },
    getNominationRating(item, isTeam = false) {
      if (!item) return [];
      const rating = [];
      for (let i = 0; i < item.leaders.length; i += 1) {
        const it = {
          number: item.leaders[i].position.toString(),
          name: isTeam ? item.leaders[i].teamName : `${item.leaders[i].lastName} ${item.leaders[i].firstName}`,
          value: item.leaders[i].points.toString(),
          current: isTeam ? item.leaders[i].isCurrentTeam === true : item.leaders[i].isCurrentUser === true,
        };
        rating.push(it);
      }
      return rating;
    },
    getAvatarImage(avatar) {
      if (!avatar) return '';
      if (!avatar.type) return '';
      if (avatar.type === 'custom') {
        return avatar.url || '';
      }
      const found = Avatars.filter((i) => i.id === avatar.type);
      if (found.length === 0) return '';
      return found[0].img || '';
    },
    updateHeight() {
      const itemsSlider = document.getElementById(this.nominationsSliderId);
      if (itemsSlider === null) return;
      if (itemsSlider.offsetHeight > 0) {
        this.nominationsSliderHeight = itemsSlider.offsetHeight;
      }
    },
    isRatingTypeDisabled(index) {
      if (index === 0) {
        if (this.nominationsActive ? this.nominationsActive.total === 0 : true) return true;
      }
      if (index === 1) {
        if (this.isTeamRatingsDisabled()) return true;
        if (this.teamNominationsActive ? this.teamNominationsActive.total === 0 : true) return true;
      }
      return false;
    },
    isTeamRatingsDisabled() {
      return !this.isTeamSet && this.disableTeamsForGuest;
    },
    clearHash() {
      setTimeout(() => { window.location.hash = ''; }, 100);
    },
    setBannersBlocks() {
      this.getBanners()
        .then(() => {
          if (this.contentStatus === 200) {
            this.bannersItems = this.banners || [];
          }
        });
    },
    disciplineIcon(task) {
      const disciplineIconMap = {
        Invite: 'invite',
        Running: 'running',
        Cycling: 'cycling',
        Skiing: 'skiing',
        Swimming: 'swimming',
        Walking: 'walking',
        Quiz: 'quiz',
        Survey: 'quiz',
        GeoLocation: 'geolocation',
        PartnerLink: 'partnerlink',
        Registration: 'registration',
        Participation: 'participation',
        UploadImage: 'uploadimage',
        Fitness: 'heart',
        Strength: 'heart',
        MartialArts: 'heart',
        Playing: 'heart',
        Extreme: 'heart',
        Outdoor: 'heart',
        Dancing: 'heart',
      };

      const heartDisciplines = [
        'Fitness', 'Strength', 'MartialArts', 'Playing', 'Extreme', 'Outdoor', 'Dancing',
      ];

      if (!task) return [];

      const icons = [];
      let hasHeart = false;

      // Проверяем наличие дисциплин в exerciseChainInfo для цепочек
      if (task.exerciseChainInfo?.disciplines) {
        task.exerciseChainInfo.disciplines.forEach((discipline) => {
          if (heartDisciplines.includes(discipline)) {
            hasHeart = true;
          } else {
            const icon = disciplineIconMap[discipline] || '';
            if (icon && !icons.includes(icon)) {
              icons.push(icon);
            }
          }
        });
        if (hasHeart) icons.unshift('heart');
        return icons;
      }

      // Если task.tasks существует, обрабатываем его
      if (task.tasks) {
        const uniqueIcons = new Set();
        for (let i = 0; i < task.tasks.length; i += 1) {
          const discipline = task.tasks[i].settings.Discipline;
          if (heartDisciplines.includes(discipline)) {
            hasHeart = true;
          } else {
            const icon = disciplineIconMap[discipline] || '';
            if (icon && !uniqueIcons.has(icon)) {
              uniqueIcons.add(icon);
              icons.push(icon);
            }
          }
        }
        if (hasHeart) icons.unshift('heart');
        return icons;
      }

      return [];
    },
    checkAndShowFeedback() {
      this.checkResetFeedbackNotificationDate();

      if (!this.isFeedbackEnabled || this.isMobileApp) return;

      this.getQuestionnaire()
        .then(() => {
          if (this.questionnaireStatus === 200) {
            const isAnyDialogShown = this.isAnyDialogShown();
            if (!this.questionnaire.answers) return;
            const found = this.questionnaire.answers.filter((i) => i.key === this.hideFeedbackNotificationKey);
            if (found.length === 0) {
              if (!isAnyDialogShown) {
                this.showNotifications = true;
                setTimeout(() => { this.showNotification(); }, 100);
              }
              return;
            }

            const duration = found[0].value;
            if (Date.now() >= parseInt(duration, 10)) {
              if (!isAnyDialogShown) {
                this.showNotifications = true;
                setTimeout(() => { this.showNotification(); }, 100);
              }
            }
          }
        });
    },
    showNotification() {
      const notification = {
        props: {
          title: 'Оцените БегунДа',
          text: 'Оцените удобство использования программы',
          img: '/img/feedback.svg',
          declineText: 'Не сейчас',
          confirmText: 'Оценить',
        },
        confirm: () => {
          // Показать виджет Userback
          this.onFeedback();
        },
        decline: () => {
          // Скрыть уведомление на 7 суток
          const date = (Date.now() + 7 * 24 * 60 * 60 * 1000).toString();
          this.saveDuration(date);
        },
        dismiss: () => {
          // Скрыть уведомление на 7 суток
          const date = (Date.now() + 7 * 24 * 60 * 60 * 1000).toString();
          this.saveDuration(date);
        },
      };

      if (this.profileCreatedOn) {
        const created = dayjs.utc(this.profileCreatedOn);
        if (created.isValid()) {
          const days = dayjs.utc().diff(created, 'days');
          if (days < 1) return;
        }
      }

      if (this.$root.$addNotification && !this.isAnyDialogShown()) {
        this.$root.$addNotification(notification);
        this.checkAndHideNotification();
      }
    },
    saveDuration(duration) {
      const answers = {};
      answers[this.hideFeedbackNotificationKey] = duration;
      this.applyAnswers(answers)
        .then(() => {
          if (this.questionnaireStatus === 204) {
            this.getQuestionnaire();
          }
        });
    },
    isAnyDialogShown() {
      return this.welcomeModal || this.questionnaireModal || this.taskDetailsModal || this.rulesPrizesModal
        || this.distanceCharityModal || this.modalTrainings || this.modalTrainingsInfo || this.modalTrainingsFinish
        || this.modalTrainingsPrice || this.quizModal || document.body.classList.contains('has-modal');
    },
    checkAndHideNotification() {
      if (this.$route.name !== 'Dashboard') return;
      if (this.isAnyDialogShown()) this.showNotifications = false;
      setTimeout(() => { this.checkAndHideNotification(); }, 100);
    },
    setUserbackEventListener() {
      if (this.$route.name !== 'Dashboard') return;
      const container = document.getElementById('userback_button_container');
      if (!container) {
        setTimeout(() => { this.setUserbackEventListener(); }, 50);
        return;
      }
      const button = container.querySelector('button.userback-controls-send.userback-button-input');
      if (!button) {
        setTimeout(() => { this.setUserbackEventListener(); }, 50);
        return;
      }
      button.addEventListener('click', this.onUserbackSend);
    },
    checkResetFeedbackNotificationDate() {
      const itemName = 'resetFeedbackNotificationDate';
      const reset = localStorage.getItem(itemName) === 'true';
      if (!reset) return;
      const date = '0';
      this.saveDuration(date);
      localStorage.removeItem(itemName);
    },
  },
  mounted() {
    this.getSteps()
      .then(() => {
        this.stepsCount = this.steps ? this.steps.target : 0;
      });
    this.fetchStepsHistory();
    this.checkProfile();
    if (this.themeDone) {
      this.setBannersBlocks();
      if (this.showIndexOFP) this.getIndexes();
    }
  },
  beforeDestroy() {
    window.removeEventListener('hashchange', this.onHashChange);
  },
};
</script>

<style lang="scss" scoped>
  @import "./Dashboard";
</style>
